import React, { useEffect, useState } from "react";
import TopNav from "../components/TopNav/TopNav";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import jwt_decode from "jwt-decode";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import "../css/custom.css";
import "../css/LoadingBars.css";
import { GlobalStore } from "../components/GlobalStore";
import WaveformAnalysisTab from "../components/tabs/WaveformAnalysis/WaveformAnalysisTab";
import TrendingAnalysisTab from "../components/tabs/TrendingAnalysis/TrendingAnalysis";
import EventsAnalysisTab from "../components/tabs/EventsAnalysisTab";
//import EventsAnalysisTab from '../components/tabs/EventsAnalysis/EventsAnalysis';
import HarmonicAnalysisTab from "../components/tabs/HarmonicAnalysisTab";
import NotificationSettings from "../components/tabs/NotificationSettings";
import OverviewTab from "../components/tabs/Overview/Overview";
import MobileUnit from "../components/tabs/MobileUnit/MobileUnit";
import { equipmentsPortfolioActions } from "../store/equipmentsPortfolioSlice/equipmentPortfolioSlice";
import { tabStatusActions } from "../store/tabStatusSlice/tabStatusSlice";
import { userActions } from "../store/userSlice/userSlice";
import { useSelector } from "react-redux";

import CommonAPI from "../api/CommonApi";
import jwtDecode from "jwt-decode";
import ChangeLog from "../components/ChangeLog/ChangeLog";

const { setIntervalAsync } = require("set-interval-async/fixed");

export const TimezoneContext = React.createContext();

export default function Dashboard() {
    const token = Cookies.get("Session");
    const dispatch = useDispatch();

    const customer = useSelector((state) => state.equipmentsPortfolio.customerList[0].label);
    const hasOverviewTab = customer === "Georgia Pacific" || customer === "Factory Mutual Insurance Company";

    const { earlyAccess, mobileUnitAdmin } = useSelector((state) => state.user);

    const [activeTabKey, setActiveTabKey] = useState(hasOverviewTab ? "Overview" : "Waveform");
    useEffect(() => {
        setActiveTabKey(hasOverviewTab ? "Overview" : "Waveform");
    }, [hasOverviewTab]);

    const [displayChangeLog, setDisplayChangeLog] = useState(false);
    const onVersionChangeClick = () => {
        setDisplayChangeLog(true);
    };

    const plotEvent = useSelector((state) => state.plotEvent);
    useEffect(() => {
        if (plotEvent.time) {
            setActiveTabKey("Events");
            dispatch(tabStatusActions.setSelectedTab("Events"));
        }
    }, [plotEvent]);

    const check_jwt_expiry = () => {
        const token = Cookies.get("Session");
        let tokenDuration = new Date().getTime();
        if (token !== undefined) {
            tokenDuration = new Date(jwt_decode(token).exp * 1000).getTime();
        }

        if (new Date().getTime() >= tokenDuration) {
            Cookies.remove("Session");
            Cookies.remove("portalSession");
            window.location = process.env.REACT_APP_PORTAL_URL + "/#/logout/";
        }
    };

    const check_early_access = () => {
        return jwt_decode(token).earlyAccess;
    };

    const check_internal_user = () => {
        return jwt_decode(token).internal;
    };

    const check_mobile_unit_admin = () => {
        return jwt_decode(token).mob;
    };

    useEffect(() => {
        setIntervalAsync(check_jwt_expiry, 10000);
        CommonAPI.getCustomerPortfolio(token).then((response) =>
            dispatch(equipmentsPortfolioActions.setEquipmentPortfolio(response.data.content)),
        );
        dispatch(userActions.setEarlyAccess(check_early_access()));
        dispatch(userActions.setInternalUser(check_internal_user()));
        dispatch(userActions.setMobileUnitAdmin(check_mobile_unit_admin()));
    }, []);

    if (!customer) {
        ///-----Insert Loading Page -----///
        return <div />;
    }

    return (
        <div className="body">
            <React.Fragment>
                <Container fluid hidden={displayChangeLog}>
                    <GlobalStore>
                        <Row>
                            <Col>
                                <TopNav />
                            </Col>
                        </Row>
                        <br></br>
                        <Row>
                            <Col>
                                <Tabs
                                    defaultActiveKey="Waveform"
                                    id="menu-tabs"
                                    variant="pills"
                                    onSelect={(tabName) => {
                                        dispatch(tabStatusActions.setSelectedTab(tabName));
                                        setActiveTabKey(tabName);
                                    }}
                                    activeKey={activeTabKey}
                                >
                                    {hasOverviewTab && (
                                        <Tab eventKey="Overview" title="Overview">
                                            <OverviewTab />
                                        </Tab>
                                    )}
                                    <Tab eventKey="Waveform" title="Waveform Analysis">
                                        <WaveformAnalysisTab />
                                    </Tab>
                                    <Tab eventKey="Harmonic Analysis" title="Harmonic Analysis">
                                        <HarmonicAnalysisTab />
                                    </Tab>
                                    <Tab eventKey="Trending Analysis" title="Trending Analysis">
                                        <TrendingAnalysisTab />
                                    </Tab>
                                    <Tab eventKey="Events" title="Events Analysis">
                                        <EventsAnalysisTab />
                                    </Tab>
                                    <Tab eventKey="Notifications" title="Notifications Settings">
                                        <NotificationSettings />
                                    </Tab>
                                    {mobileUnitAdmin && (
                                        <Tab eventKey="Mobile" title="Mobile Unit">
                                            <MobileUnit />
                                        </Tab>
                                    )}
                                </Tabs>
                            </Col>
                        </Row>
                        <Row>
                            <Col className="mt-5 offset-5">
                                <h6>
                                    Version 5.1.11{" "}
                                    <a className="changelog-link" onClick={onVersionChangeClick}>
                                        See What's Changed
                                    </a>
                                </h6>{" "}
                            </Col>
                        </Row>
                    </GlobalStore>
                </Container>
                <Container fluid id="changelog" hidden={!displayChangeLog}>
                    <ChangeLog setDisplayChangeLog={setDisplayChangeLog} hidden={!displayChangeLog} />
                </Container>
            </React.Fragment>
        </div>
    );
}
